import { GameMaterialInterface } from 'app/shared/interfaces/GameMaterial.interface';

export const getMaterialNotInQueue = (gameMaterials: Array<GameMaterialInterface>) => {
  return gameMaterials.length ? gameMaterials.filter((material) => material.deliveryStatus === 1) : [];
};
